import { IListing } from '../../@types/listing';
import { isFixed } from '../styles';

export const isKnockIntegrated = (listing: IListing) => {
  return !!(listing?.knock_community_id && listing?.knock_init_key);
};

export const isBetterBotIntegrated = (listing: IListing) =>
  !!listing?.betterbot_subdomain;

export const removeFirstResidentDuplicate = <T extends { id?: number | null }>(
  residents: T[]
) => {
  const results: T[] = [];
  const history = new Set<number>();

  for (const resident of residents) {
    const id = resident?.id ?? undefined;

    if (id != null && !history.has(id)) {
      results.push(resident);
      history.add(id);
    }
  }

  return results;
};

export const canUseCompact = (listing: IListing | null, config: any) => {
  if (!listing) return false;
  if (!isFixed(config.renderAs)) {
    return false;
  }

  if (isKnockIntegrated(listing) || isBetterBotIntegrated(listing)) {
    return listing.smaller_messenger_design;
  }

  return true;
};
